import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { normalizeTaskDueDate } from '@/modules/common/helpers/normalizeTaskDueDate.ts';

dayjs.extend(utc);
dayjs.extend(timezone);

export const TASKS_TIMEZONE = 'Australia/Sydney';

const UI_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS';

const getTaskDateValue = (value: string | Dayjs) =>
  typeof value === 'string' ? dayjs(value).format('YYYY-MM-DD') : value.format('YYYY-MM-DD');

export const taskDateBoundaryToUtcIso = (value: string | Dayjs, boundary: 'start' | 'end') => {
  const time = boundary === 'start' ? '00:00:00.000' : '23:59:59.999';
  return dayjs
    .tz(`${getTaskDateValue(value)} ${time}`, UI_DATE_TIME_FORMAT, TASKS_TIMEZONE)
    .utc()
    .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
};

export const formatTaskDateTime = (value?: string | null) => {
  if (!value) return '-';
  return dayjs.utc(normalizeTaskDueDate(value)).tz(TASKS_TIMEZONE).format('DD-MM-YYYY, HH:mm');
};

export const formatTaskDateTimeWithLocalTime = (value?: string | null) => {
  const taskDateTime = formatTaskDateTime(value);
  if (!value) return { taskDateTime, localDateTime: null };

  const localDateTime = dayjs.utc(normalizeTaskDueDate(value)).local().format('DD-MM-YYYY, HH:mm');

  return {
    taskDateTime,
    localDateTime: localDateTime === taskDateTime ? null : localDateTime,
  };
};

export const getNowInTaskTimeZone = () => dayjs().tz(TASKS_TIMEZONE);
